var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v(" USPS Change-of-Address"),_c('sup',[_vm._v("®")])])])
}]

export { render, staticRenderFns }